export default "__VITE_ASSET__6683a049__"